module.exports = __webpack_public_path__ + "img/elevatorVideoLog.24a249a8.jpg";